import ColumnContext from "../column-context";
import React from "react";
import { FunctionComponent } from "react";
import { IProps } from "./column-provider.types";

export const ColumnProvider: FunctionComponent<IProps> = ({ children, ...context }) => {
    return <ColumnContext.Provider value={context}>{children}</ColumnContext.Provider>;
};

export default ColumnProvider;
